import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@ipreo/northstar';
import {
  MMDRead,
  MMDReads,
  MMDReadsServiceModel,
  MMDServiceModel
} from '../models/mmd-read';
import { DEFAULT_TIMEZONE } from './calendar.service';

@Injectable()
export class MMDService {
  private muniApiHost: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(ENVIRONMENT_CONFIG) config: EnvironmentConfig
  ) {
    this.muniApiHost = config.params.muniApiHost as string;
  }

  public fetchData(date: Date): Observable<MMDReads> {
    const requestedDate: string = moment(date).format('MM-DD-YYYY');

    return this.http
      .get(`${this.muniApiHost}/mmd/reads?date=${requestedDate}`)
      .pipe(map((res: MMDServiceModel[]) => this.mmdReadsToViewModel(res[0])));
  }

  public mmdReadsToViewModel(mmdReads: MMDServiceModel): MMDReads {
    if (mmdReads) {
      const timeOfDay: string =
        momentTz(mmdReads.timeOfDay).tz(DEFAULT_TIMEZONE).format('h:mm A') +
        ' ET';

      const reads: MMDRead[] = mmdReads.mmd_reads.map(
        (mmdRead: MMDReadsServiceModel) => {
          let change: string;
          const years = `${mmdRead.startYear}-${mmdRead.endYear}`;
          const isBump: boolean = mmdRead.direction === 'bump';
          const isCut: boolean = mmdRead.direction === 'cut';

          switch (mmdRead.range.length) {
            case 0:
              change = mmdRead.direction;
              break;
            case 1:
              change = `${mmdRead.range[0]}bp ${mmdRead.direction}`;
              break;
            case 2:
              change = `${mmdRead.range[0]}-${mmdRead.range[1]}bp ${mmdRead.direction}`;
              break;
            default:
              break;
          }

          return { years, change, isBump, isCut } as MMDRead;
        }
      );

      return { timeOfDay, reads, readType: mmdReads.readType };
    } else {
      return {
        timeOfDay: undefined,
        reads: [],
        readType: undefined
      };
    }
  }
}
